var _defs, _polygon, _line, _line2, _line3, _line4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSymbolpackNew252({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;stroke:#fff;stroke-miterlimit:10;stroke-width:0.5px;}"))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "a",
    points: "8 10.7 11.12 5.3 4.88 5.3 8 10.7"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "a",
    x1: 0.36,
    y1: 8,
    x2: 3.04,
    y2: 8
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "a",
    x1: 3.86,
    y1: 8,
    x2: 6.54,
    y2: 8
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "a",
    x1: 9.46,
    y1: 8,
    x2: 12.14,
    y2: 8
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "a",
    x1: 12.96,
    y1: 8,
    x2: 15.64,
    y2: 8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSymbolpackNew252);
export default __webpack_public_path__ + "static/media/Symbolpack_New_252.8906e7aafcf79a3f702d566ee3dabcb7.svg";
export { ForwardRef as ReactComponent };